import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';
import CardSwap, { Card } from './CardSwap';
import horizontalImage1 from '../images/herocarousel/horizontal/1.jpg';
import horizontalImage2 from '../images/herocarousel/horizontal/2.png';
import horizontalImage3 from '../images/herocarousel/horizontal/3.jpg';
import horizontalImage4 from '../images/herocarousel/horizontal/4.png';

const Hero = () => {
  const navigate = useNavigate();
  const [titleText, setTitleText] = useState('');
  const [descriptionText, setDescriptionText] = useState('');
  const [titleIndex, setTitleIndex] = useState(0);
  const [descriptionIndex, setDescriptionIndex] = useState(0);
  const [isTypingTitle, setIsTypingTitle] = useState(true);
  const [showCursor, setShowCursor] = useState(true);
  const [isComplete, setIsComplete] = useState(false);

  const fullTitle = 'Your hunter for digital marketing solutions.';
  const fullDescription = 'Using data-driven facts as our bow, and strategies as our arrow';
  
  // Images for card swap - using horizontal carousel images
  const portfolioImages = [
    { src: horizontalImage1, alt: 'Digital Marketing Excellence' },
    { src: horizontalImage2, alt: 'Strategic Brand Development' },
    { src: horizontalImage3, alt: 'Social Media Mastery' },
    { src: horizontalImage4, alt: 'Creative Solutions' }
  ];

  useEffect(() => {
    const typingSpeed = 80; // milliseconds between each character

    const handleTyping = () => {
      if (isTypingTitle && titleIndex < fullTitle.length) {
        // Typing the title
        setTitleText(fullTitle.substring(0, titleIndex + 1));
        setTitleIndex(titleIndex + 1);
      } else if (isTypingTitle && titleIndex === fullTitle.length) {
        // Title complete, start typing description after a brief pause
        setTimeout(() => {
          setIsTypingTitle(false);
        }, 300);
      } else if (!isTypingTitle && descriptionIndex < fullDescription.length) {
        // Typing the description
        setDescriptionText(fullDescription.substring(0, descriptionIndex + 1));
        setDescriptionIndex(descriptionIndex + 1);
      } else if (!isTypingTitle && descriptionIndex === fullDescription.length) {
        // Both complete, hide cursor after a moment
        setTimeout(() => {
          setIsComplete(true);
          setShowCursor(false);
        }, 500);
      }
    };

    if (!isComplete) {
      const timer = setTimeout(handleTyping, typingSpeed);
      return () => clearTimeout(timer);
    }
  }, [titleIndex, descriptionIndex, isTypingTitle, fullTitle, fullDescription, isComplete]);

  // Cursor blinking effect (only while typing)
  useEffect(() => {
    if (!isComplete) {
      const cursorTimer = setInterval(() => {
        setShowCursor(prev => !prev);
      }, 500);

      return () => clearInterval(cursorTimer);
    }
  }, [isComplete]);

  const handleLearnMore = () => {
    navigate('/about-us');
  };

  // Function to render text with highlighted words
  const renderTypedText = (text) => {
    // Replace "hunter" and "solutions" with highlighted spans
    return text
      .replace(/hunter/gi, '<span class="text-highlight-hunter">hunter</span>')
      .replace(/solutions/gi, '<span class="text-highlight-solutions">solutions</span>');
  };

  return (
    <section className="hero-section" id="hero">
      <div className="hero-background-images">
        <CardSwap
          width={600}
          height={400}
          cardDistance={60}
          verticalDistance={70}
          delay={4000}
          pauseOnHover={true}
          skewAmount={4}
          easing="elastic"
        >
          {portfolioImages.map((image, index) => (
            <Card key={index}>
              <img 
                src={image.src} 
                alt={image.alt}
                className="card-image"
                loading="lazy"
                decoding="async"
              />
            </Card>
          ))}
        </CardSwap>
      </div>
      
      <div className="hero-content">
        <div className="hero-text-content">
          <h1 className="hero-title">
            <span 
              dangerouslySetInnerHTML={{ 
                __html: renderTypedText(titleText) + 
                       (isTypingTitle && showCursor ? '<span class="typing-cursor">|</span>' : '') 
              }} 
            />
          </h1>
          <p className="hero-description">
            {descriptionText}
            {!isTypingTitle && !isComplete && showCursor && <span className="typing-cursor">|</span>}
          </p>
          <div className="hero-buttons">
            <button className="btn-primary" onClick={handleLearnMore}>
              Learn More
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;